let authToken = '';

export default {
  setAuthToken(token) {
    if (!token) throw new Error('token is required');

    authToken = token;
  },
  getAuthToken() {
    return authToken;
  },
  removeAuthToken() {
    authToken = null;
  }
};



// WEBPACK FOOTER //
// ./src/api/auth/helper.js